import {
  ArrowBackOutlined,
  CloudDownloadOutlined,
  LowPriorityOutlined,
  RefreshOutlined,
  RemoveRedEyeOutlined
} from "@material-ui/icons";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  CardHeader,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { frFR } from "@mui/x-data-grid/locales";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useConfirm from "../../../../../hooks/useConfirm";
import useCrudApi from "../../../../../hooks/useCrudApi";
import { useQuery } from "../../../../../hooks/useQuery";
import useToast from "../../../../../hooks/useToast";
import { AssociationService_adm } from "../../../../../service/admin_service/AssociationService_adm";
import { AMIService } from "../../../../../service/AMI/AMIService";
import { AssociationCandidatService } from "../../../../../service/AssociationCandidatService";
import { TYPE_NOTIFICATION } from "../../../shares/NotificationBull";
import AppTypography from "../../../shares/reusable/AppTypography";
import PriorisationDialogForm from "../depouillement/PriorisationDialogForm";

const VolontariatList = ({ selection = false, id_type, handleSelectedCV }) => {
  const [associations, setAssociations] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [idButtonDownloads, setIdButtonDownloads] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [openPriosisationDialog, setOpenPriosisationDialog] = useState(false);
  const navigate = useNavigate();
  const [filtre, setFiltre] = useState({});
  const { Toast, showToast } = useToast();
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const url = useQuery();
  const job_id = url.get("offre_id");
  const amiApi = useCrudApi(AMIService);

  const afficherMembre = (row) => {
    navigate(
      `agence-membres?ref=${row.association_uuid}&offre_id=${row.id_type}`,
    );
  };

  const handleGoBack = () => {
    navigate(-1);
  };
  const handleFetchAssociationList = () => {
    setDataLoading(true);
    AssociationCandidatService.getAssociationCandidatureByType({
      ...filtre,
      id_type: job_id,
    })
      .then((res) => {
        if (res && res.data) {
          setAssociations(res.data);
          setFilteredRows(res.data);
        } else {
          setAssociations([]);
          setFilteredRows([]);
        }
      })
      .finally(() => {
        setDataLoading(false);
      });
  };

  const handleFilter = (filtre) => {
    if (!filtre || String(filtre).trim() === "") {
      setFilteredRows(associations);
      return;
    }
    const mots = filtre
      .toLowerCase()
      .split(" ")
      .filter((mot) => mot.trim() !== "");
    setFilteredRows(
      associations.filter((item) =>
        mots.every((mot) =>
          Object.values(item).some(
            (val) => val && val.toString().toLowerCase().includes(mot),
          ),
        ),
      ),
    );
  };

  const handleSelectAsssociation = (association) => {
    openConfirmDialog(
      "Selectionner l'agence / association",
      "Voulez-vous vraiment ajouter cette Agence / Association parmis les associations à gerer?",
      () => {
        handleConfirmSelectionAssociation(association);
      },
    );
  };

  const handleConfirmSelectionAssociation = (association) => {
    AssociationService_adm.insertSelectedAssociation(association).then(
      (res) => {
        if (res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFetchAssociationList();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      },
    );
  };

  const handleRemoveIdToLoad = (id) => {
    setIdButtonDownloads((prev) => prev.filter((item) => item !== id));
  };

  const handleAddIdToLoad = (id) => {
    setIdButtonDownloads((prev) => [...prev, id]);
  };

  const handleConfirmDownload = (row) => {
    openConfirmDialog(
      "Confirmation",
      "Voulez-vous vraiment télécharger les pièces jointes de cette Agence / Association ?",
      () => {
        handleDownloadAssociationPj(row);
      },
    );
  };

  const handleDownloadAssociationPj = (row) => {
    handleAddIdToLoad(row.id_ext_asso_candidat);
    AssociationCandidatService.downloadUploadedFileByAssociation({
      id_ext_association: row.id_ext_association,
      id_type: job_id,
    })
      .then((response) => {
        if (response.status === 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            row.association_nom + " au lot " + row.libelle_type + ".zip",
          );
          document.body.appendChild(link);
          link.click();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, "Aucun fichier à télécharger");
        }
      })
      .catch((error) => {
        showToast(TYPE_NOTIFICATION.ERROR, "Aucun fichier à télécharger");
      })
      .finally(() => {
        handleRemoveIdToLoad(row.id_ext_asso_candidat);
      });
  };

  const handleTransformAssoToSeletedAsso = (asso) => {
    return {
      ext_asso_id: asso.id_ext_association,
    };
  };

  const table_colonne = [
    /* {
      field: "asso_note",
      headerName: "Note",
      flex: 1,
      minWidth: 150,
    }, */
    {
      field: "association_nom",
      headerName: "Nom de l'agence / association",
      flex: 1,
      minWidth: 150,
    },
    {
      // field: "created_at",
      field: "adresse",
      headerName: "Localisation",
      minWidth: 150,
    },
    {
      // field: "created_at",
      field: "annee_creation",
      headerName: "Année de création",
      minWidth: 150,
    },
    {
      field: "created_at",
      headerName: "Date de soumission",
      minWidth: 120,
    },
    {
      field: "num_nif",
      headerName: "NIF",
      minWidth: 120,
    },
    {
      field: "num_stat",
      headerName: "STAT",
      minWidth: 120,
    },
   /*  {
      field: "nb_membre",
      headerName: "Membres",
      flex: 0.8,
      minWidth: 120,
    }, */
    {
      field: "action",
      headerName: "Actions",
      minWidth: 180,
      renderCell: (params) => {
        return (
          <Grid>
            <IconButton
              loading={idButtonDownloads.includes(
                params.row.id_ext_asso_candidat,
              )}
              title="Telecharger les pieces jointes"
              color="primary"
              onClick={(e) => handleConfirmDownload(params.row)}
            >
              <CloudDownloadOutlined />
            </IconButton>
            <IconButton
              title="Afficher membre"
              color="primary"
              onClick={(e) => afficherMembre(params.row)}
            >
              <RemoveRedEyeOutlined />
            </IconButton>
           {/*  <IconButton
              title="Selectionner l'agence / association"
              color="secondary"
              onClick={(e) =>
                handleSelectAsssociation(
                  handleTransformAssoToSeletedAsso(params.row),
                )
              }
            >
              <CheckOutlined />
            </IconButton> */}
          </Grid>
        );
      },
    },
  ];

  const handleOpenRepriorisationAssociation = () => {
    setOpenPriosisationDialog(true);
  };

  const handleCloseRepriorisationAssociation = () => {
    setOpenPriosisationDialog(false);
  };

  useEffect(() => {
    handleFetchAssociationList();
  }, []);

  useEffect(() => {
    if (job_id) {
      amiApi.findOne(job_id);
    }
  }, [job_id]);

  return (
    <>
      <DialogComponent />
      <Toast />
      <PriorisationDialogForm
        idOffre={job_id}
        open={openPriosisationDialog}
        onFormClose={handleCloseRepriorisationAssociation}
      />
      <Grid width={"100%"}>
        <Paper elevation={0}>
          <Grid>
            <CardHeader
              title={
                <Grid
                  item
                  sx={{
                    display: { xs: "none", sm: "block" },
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    fontSize: {
                      xs: "0.875rem",
                      sm: "1rem",
                      md: "1.25rem",
                      lg: "1.5rem",
                    },
                  }}
                  // xs={10}
                >
                  <AppTypography
                    titre={amiApi.data.findOneById?.data.libelle_type}
                    text={
                      `Candidat au "${amiApi.data.findOneById?.data.libelle_type.substring(0, 40)} ` +
                      (amiApi.data.findOneById?.data.libelle_type.length > 40
                        ? '..."'
                        : '"')
                    }
                    loading={amiApi.loading.findOneById}
                    variant="h5"
                  />
                </Grid>
              }
              titleTypographyProps={{ variant: "h5" }}
              avatar={
                <IconButton color="primary" onClick={handleGoBack}>
                  <ArrowBackOutlined />
                </IconButton>
              }
              action={
                <Grid container spacing={1} alignItems={"center"}>
                  <Grid item>
                    <TextField
                      id="recherche"
                      fullWidth
                      size="small"
                      onChange={(e) => handleFilter(e.target.value)}
                      placeholder="Recherche"
                      InputProps={{
                        endAdornment: (
                          <IconButton>
                            <SearchIcon />
                          </IconButton>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <IconButton
                      color="primary"
                      title="Actualiser"
                      onClick={handleFetchAssociationList}
                    >
                      <RefreshOutlined />
                    </IconButton>
                  </Grid>
                  <Grid item>
                    <Button
                      title="Réordonner les associations (Numérotation) par pertinance"
                      color="primary"
                      onClick={handleOpenRepriorisationAssociation}
                      startIcon={<LowPriorityOutlined />}
                      // variant="outlined"
                    >
                      Ordonner
                    </Button>
                  </Grid>
                </Grid>
              }
            />
            <Grid container>
              <Box display={dataLoading ? "" : "none"} sx={{ width: "100%" }}>
                <LinearProgress />
              </Box>
              <DataGrid
                sx={{
                  width: {
                    xs: "75.5vw",
                    sm: "90vw",
                    md: "93.5vw",
                    lg: "79.5vw",
                    height: "60vh",
                  },
                }}
                columns={table_colonne}
                rows={filteredRows}
                getRowId={(row) => row.id_ext_asso_candidat}
                localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

export default VolontariatList;
